<template>
  <nav class="b-steps non-printable" aria-label="Steg i beställningen">
    <button
      v-for="(label, i) in labels"
      :key="i"
      type="button"
      class="b-step"
      :class="{
        'is-active': i === current,
        'is-done': i < current,
        'is-clickable': isClickable(i),
      }"
      :disabled="!isClickable(i)"
      :aria-current="i === current ? 'step' : undefined"
      @click="isClickable(i) && $emit('go', i)"
    >
      <span class="b-step-number">{{ i + 1 }}</span>
      <span class="b-step-label">{{ label }}</span>
    </button>
  </nav>
</template>

<script>
export default {
  name: 'StepIndicator',
  props: {
    labels: { type: Array, required: true },
    current: { type: Number, required: true },
    // Speglar "Nästa"-knappen: är den aktiv får man klicka sig fram ett steg.
    canAdvance: { type: Boolean, default: false },
  },
  emits: ['go'],
  methods: {
    // Passerade steg går alltid att gå tillbaka till. Nästa steg öppnas
    // först när innevarande steg är komplett.
    isClickable(i) {
      return i < this.current || (i === this.current + 1 && this.canAdvance)
    },
  },
}
</script>
